import { render, staticRenderFns } from "./wlShipCard.vue?vue&type=template&id=5c30da77&scoped=true&"
import script from "./wlShipCard.vue?vue&type=script&lang=js&"
export * from "./wlShipCard.vue?vue&type=script&lang=js&"
import style0 from "./wlShipCard.vue?vue&type=style&index=0&id=5c30da77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30da77",
  null
  
)

export default component.exports